import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { INTERVAL_UNITS, InspectionType } from '../../models/inspection.models';
import { VehicleInspectionService } from '../../services/vehicle-inspection.service';

/** New and edit inspection type (edit when the route has an :id). */
@Component({
    selector: 'app-inspection-type-edit',
    templateUrl: './inspection-type-edit.component.html',
    standalone: false
})
export class InspectionTypeEditComponent implements OnInit {
  type: InspectionType = new InspectionType();
  readonly units = INTERVAL_UNITS;
  error: string = '';
  busy: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private service: VehicleInspectionService) { }

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id > 0) {
      this.service.getType(id).pipe(take(1)).subscribe({
        next: (t) => this.type = t,
        error: () => this.error = 'This inspection type could not be loaded.',
      });
    }
  }

  isValid(): boolean {
    const n = Number(this.type.intervalNumber);
    const len = Number(this.type.defaultDurationMinutes);
    return !!this.type.name.trim() && Number.isInteger(n) && n >= 1 && /^#[0-9a-fA-F]{6}$/.test(this.type.colour)
      && Number.isInteger(len) && len >= 15 && len <= 720 && len % 15 === 0;
  }

  save(): void {
    this.error = '';
    if (!this.isValid()) {
      this.error = 'Please complete all required fields';
      return;
    }
    this.busy = true;
    this.service.saveType(this.type).pipe(take(1)).subscribe({
      next: () => this.router.navigateByUrl('/workshop/inspection-types'),
      error: (e) => {
        this.busy = false;
        this.error = (e && e.error && e.error.message) || 'Something went wrong. Please try again later.';
      },
    });
  }
}
